import React from "react";
import { Row, Col, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { FileText, BarChart, TrendingUp, PieChart, MessageSquare, Users } from "react-feather";

const categoryColors = {
  "Feedback Reports": "#007bff",
};

const feedbackReports = [
  {
    category: "Feedback Reports",
    reports: [
      { icon: <FileText />, title: "Survey Overview", description: "High-level summary of all surveys and responses.", link: "/feedback/feedback-reports/overview" },
      { icon: <BarChart />, title: "Response Details", description: "Full list of responses with guest details and ratings.", link: "/reports/response-details" },
      { icon: <TrendingUp />, title: "NPS & CSAT Trends", description: "Track customer loyalty and satisfaction over time.", link: "/reports/nps-csat-trends" },
      { icon: <PieChart />, title: "Category Performance", description: "Compare ratings across survey categories (e.g., staff, cleanliness).", link: "/reports/category-performance" },
      { icon: <MessageSquare />, title: "Text & Sentiment Analysis", description: "Analyze open feedback and identify themes & sentiment.", link: "/reports/text-sentiment-analysis" },
      { icon: <Users />, title: "Promoter & Detractor Segments", description: "Identify promoters, passives, and detractors for follow-up.", link: "/reports/promoter-detractor-segments" },
    ],
  },
];

const quickLinks = [
  { icon: <FileText />, title: "Survey Overview", link: "/reports/survey-overview", category: "Feedback Reports" },
  { icon: <BarChart />, title: "Response Details", link: "/reports/response-details", category: "Feedback Reports" },
  { icon: <TrendingUp />, title: "NPS & CSAT Trends", link: "/reports/nps-csat-trends", category: "Feedback Reports" },
];

const FeedbackReports = ({ searchQuery }) => {
  const navigate = useNavigate();
  const handleCardClick = (link) => {
    navigate(link);
  };
  const filteredReports = feedbackReports.map((category) => ({
    ...category,
    reports: category.reports.filter(
      (report) =>
        report.title.toLowerCase().includes(searchQuery) ||
        report.description.toLowerCase().includes(searchQuery)
    ),
  })).filter((category) => category.reports.length > 0);
  const filteredQuickLinks = quickLinks.filter(
    (link) =>
      link.title.toLowerCase().includes(searchQuery) ||
      link.category.toLowerCase().includes(searchQuery)
  );
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={18} lg={20}>
        {filteredReports.map((category, index) => (
          <div key={index} className="category-section mb-4">
        
            <Row gutter={[16, 16]}>
              {category.reports.map((report, idx) => (
                <Col key={idx} xs={24} sm={12} md={12} lg={8}>
                  <Card
                    hoverable
                    style={{
                      borderLeft: `4px solid ${categoryColors[category.category]}`,
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                    onClick={() => handleCardClick(report.link)}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <div
                        style={{
                          color: categoryColors[category.category],
                          fontSize: "24px",
                          marginRight: "16px",
                          flexShrink: 0
                        }}
                      >
                        {report.icon}
                      </div>
                      <div>
                        <h5 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 8px" }}>{report.title}</h5>
                        <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>{report.description}</p>
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </Col>
      <Col xs={24} md={6} lg={4} style={{ paddingRight: 0 }}>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "16px",
            borderRadius: "8px 0 8px 8px",
            borderLeft: "4px solid #007bff",
            minHeight: "100%",
          }}
        >
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#031b4e",
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FileText size={18} style={{ marginRight: "8px", color: "#007bff" }} />
            Quick Links
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {filteredQuickLinks.map((link, idx) => (
              <li
                key={idx}
                onClick={() => handleCardClick(link.link)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  marginBottom: "4px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                className="quick-link-item"
              >
                <span
                  style={{
                    color: categoryColors[link.category],
                    marginRight: "8px",
                    fontSize: "16px",
                  }}
                >
                  {link.icon}
                </span>
                <span style={{ fontSize: "14px", color: "#333" }}>{link.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </Col>
    </Row>
  );
};

export default FeedbackReports;